import { Globe } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import type { LandingLocale } from "@/lib/landing-content";

const LANGUAGES: { code: LandingLocale; label: string; path: string }[] = [
  { code: "en", label: "English", path: "/" },
  { code: "es", label: "Español", path: "/es" },
  { code: "pt-br", label: "Português (Brasil)", path: "/pt-br" },
  { code: "de", label: "Deutsch", path: "/de" },
];

interface LanguageSelectorProps {
  current: LandingLocale;
}

export function LanguageSelector({ current }: LanguageSelectorProps) {
  const navigate = useNavigate();
  const currentLabel = LANGUAGES.find((l) => l.code === current)?.label ?? "English";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" aria-label={`Select language (current: ${currentLabel})`} className="text-xs text-muted-foreground gap-1.5">
          <Globe className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">{currentLabel}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[160px]">
        {LANGUAGES.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => navigate(lang.path)}
            className={lang.code === current ? "bg-accent font-medium" : ""}
          >
            {lang.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
